export default __webpack_public_path__ + "static/media/sorry.f22fb0c4.png";